var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-form-input',{ref:"input",class:['text-right', _vm.css],attrs:{"type":"text","value":_vm.displayValue,"state":_vm.state,"placeholder":_vm.placeholder,"disabled":_vm.disabled},on:{"input":_vm.handleInput,"blur":_vm.handleBlur,"keypress":_vm.validateKeypress}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5a851fde","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/CurrencyInput.vue
// module id = null
// module chunks = 